import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// ACTIONS
import { cadastroRgVincularDare } from 'store/modules/api/iirgd/cadastroRg/actions';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	IRequestAtualizarDare,
	atualizarDareSuccess,
	atualizarDareFailure,
} from './actions';

function* atualizarDareRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: IRequestAtualizarDare } =
		request;

	const { dare, numeroDare } = payload;
	delete payload.dare;
	delete payload.numeroDare;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		`dare/${numeroDare}/documento`,
		payload,
	);

	if (response.status === 201 || response.status === 200) {
		yield put(atualizarDareSuccess(response.data));
		yield put(cadastroRgVincularDare({ ...response.data, ...dare }));
	} else if (response.error) {
		yield put(atualizarDareFailure());
	}
}

export default all([
	takeLatest(Types.ATUALIZAR_DARE_REQUEST, atualizarDareRequest),
]);
